'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValidationVisitor = exports.validateBinderConfiguration = exports.validateQuery = undefined;

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var validateQuery = exports.validateQuery = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(queryNode) {
        var walker, validationVisitor;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        walker = new _QueryNodeWalker2.default();
                        validationVisitor = new ValidationVisitor();
                        // appContext is not currently needed.

                        _context.next = 4;
                        return walker.walk(queryNode, validationVisitor);

                    case 4:
                        return _context.abrupt('return', validationVisitor.errors);

                    case 5:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function validateQuery(_x) {
        return _ref.apply(this, arguments);
    };
}();

var validateBinderConfiguration = exports.validateBinderConfiguration = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(queryNode) {
        var walker, validationVisitor;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        walker = new _QueryNodeWalker2.default();
                        validationVisitor = new ConfigurationValidationVisitor();
                        // appContext is not currently needed.

                        _context2.next = 4;
                        return walker.walk(queryNode, validationVisitor);

                    case 4:
                        return _context2.abrupt('return', validationVisitor.errors);

                    case 5:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function validateBinderConfiguration(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

var _QueryValidationErrors = require('./QueryValidationErrors');

var _QueryValidationErrors2 = _interopRequireDefault(_QueryValidationErrors);

var _QueryNodeVisitor2 = require('./engine/QueryNodeVisitor');

var _QueryNodeVisitor3 = _interopRequireDefault(_QueryNodeVisitor2);

var _QueryNodeWalker = require('./engine/QueryNodeWalker');

var _QueryNodeWalker2 = _interopRequireDefault(_QueryNodeWalker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MustHaveAtLeastOneChild = 'Must have at least one child node.';
var MustHaveExactlyOneChild = 'Must have exactly one child node.';
var DocumentTypeIsMissing = 'The document type is missing.';
var DescriptorIsMissing = 'The descriptor is missing.';
var OperatorIsInvalid = 'The chosen operator is invalid.';
var NotEmptyValueRequired = 'Must have a non-empty value.';
var AllValuesNotEmptyRequired = 'All values must be a non-empty.';
var MustHaveAtLeastOneValue = 'Must have at least one value.';
var DataSourceIdIsMissing = 'Data source id is missing.';

// TODO: Address possible validation concerns for different portions of binder lifecycle.
// these are: at time of saving binder template (currently addressed)
//            at the time of saving the binder query (currently addressed)
//            at the time of query (unsure if different than saving the binder)

// TODO: Validate the values of various value sets based on the data type and/or cardinality
//      e.g. a date should correctly be a date, a number should correctly be a number, etc.

var ValidationVisitor = exports.ValidationVisitor = function (_QueryNodeVisitor) {
    (0, _inherits3.default)(ValidationVisitor, _QueryNodeVisitor);

    function ValidationVisitor() {
        (0, _classCallCheck3.default)(this, ValidationVisitor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ValidationVisitor.__proto__ || (0, _getPrototypeOf2.default)(ValidationVisitor)).call(this));

        _this.errors = new _QueryValidationErrors2.default();
        return _this;
    }

    (0, _createClass3.default)(ValidationVisitor, [{
        key: 'mustHaveAtLeastOneChild',
        value: function mustHaveAtLeastOneChild(node) {
            var children = node.children,
                type = node.type,
                nodeId = node.nodeId;

            if (children.length === 0) {
                this.errors.add(type, nodeId, MustHaveAtLeastOneChild);
            }
        }
    }, {
        key: 'mustHaveExactlyOneChild',
        value: function mustHaveExactlyOneChild(node) {
            var children = node.children,
                type = node.type,
                nodeId = node.nodeId;

            if (children.length !== 1) {
                this.errors.add(type, nodeId, MustHaveExactlyOneChild);
            }
        }
    }, {
        key: 'hasValidOperator',
        value: function hasValidOperator(operator, value, dataType, nodeType, nodeId) {
            var cardinality = this.errors.getValueSetCardinality(value);
            if (!this.errors.isValidOperator(operator, dataType, cardinality)) {
                this.errors.add(nodeType, nodeId, OperatorIsInvalid);
            }
        }
    }, {
        key: 'valueMustBeNonEmpty',
        value: function valueMustBeNonEmpty(value, type, nodeId, property) {
            if (this.errors.isValueMissing(value)) {
                this.errors.add(type, nodeId, NotEmptyValueRequired, property);
            }
        }
    }, {
        key: 'eachValueMustBeNonEmpty',
        value: function eachValueMustBeNonEmpty(values, type, nodeId, property) {
            var _this2 = this;

            if (values && values.some(function (value) {
                return _this2.errors.isValueMissing(value);
            })) {
                this.errors.add(type, nodeId, AllValuesNotEmptyRequired, property);
            }
        }
    }, {
        key: 'mustHaveAtLeastOneValue',
        value: function mustHaveAtLeastOneValue(values, type, nodeId, property) {
            if (!values || values.length === 0) {
                this.errors.add(type, nodeId, MustHaveAtLeastOneValue, property);
            }
        }

        // conditions

    }, {
        key: 'visitAndCondition',
        value: function visitAndCondition(context) {
            this.mustHaveAtLeastOneChild(context.currentNode);
        }
    }, {
        key: 'visitConditions',
        value: function visitConditions(context) {
            this.mustHaveAtLeastOneChild(context.currentNode);
        }
    }, {
        key: 'visitNotCondition',
        value: function visitNotCondition(context) {
            this.mustHaveExactlyOneChild(context.currentNode);
        }
    }, {
        key: 'visitOrCondition',
        value: function visitOrCondition(context) {
            this.mustHaveAtLeastOneChild(context.currentNode);
        }
    }, {
        key: 'visitDapsConditions',
        value: function visitDapsConditions(context) {
            this.mustHaveAtLeastOneChild(context.currentNode);
        }
    }, {
        key: 'visitDapsAndCondition',
        value: function visitDapsAndCondition(context) {
            this.mustHaveAtLeastOneChild(context.currentNode);
        }
    }, {
        key: 'visitDapsOrCondition',
        value: function visitDapsOrCondition(context) {
            this.mustHaveAtLeastOneChild(context.currentNode);
        }
    }, {
        key: 'visitDapsNotCondition',
        value: function visitDapsNotCondition(context) {
            this.mustHaveExactlyOneChild(context.currentNode);
        }

        // predicates

    }, {
        key: 'visitCommitDatePredicate',
        value: function visitCommitDatePredicate(context) {
            var _context$currentNode = context.currentNode,
                value = _context$currentNode.value,
                type = _context$currentNode.type,
                nodeId = _context$currentNode.nodeId,
                operator = _context$currentNode.operator;

            var dataType = context.currentNode.getDataType();
            this.hasValidOperator(operator, value, dataType, type, nodeId);
        }
    }, {
        key: 'visitDapsDescriptorPredicate',
        value: function visitDapsDescriptorPredicate(context) {
            var _context$currentNode2 = context.currentNode,
                value = _context$currentNode2.value,
                type = _context$currentNode2.type,
                nodeId = _context$currentNode2.nodeId,
                operator = _context$currentNode2.operator,
                descriptor = _context$currentNode2.descriptor;

            var dataType = context.currentNode.getDataType();
            this.hasValidOperator(operator, value, dataType, type, nodeId);
            if (!descriptor) {
                this.errors.add(type, nodeId, DescriptorIsMissing);
            }
        }
    }, {
        key: 'visitDescriptorPredicate',
        value: function visitDescriptorPredicate(context) {
            var _context$currentNode3 = context.currentNode,
                value = _context$currentNode3.value,
                type = _context$currentNode3.type,
                nodeId = _context$currentNode3.nodeId,
                operator = _context$currentNode3.operator,
                descriptor = _context$currentNode3.descriptor;

            var dataType = context.currentNode.getDataType();
            this.hasValidOperator(operator, value, dataType, type, nodeId);
            if (!descriptor) {
                this.errors.add(type, nodeId, DescriptorIsMissing);
            }
        }
    }, {
        key: 'visitDocumentStatusPredicate',
        value: function visitDocumentStatusPredicate(context) {
            var _context$currentNode4 = context.currentNode,
                value = _context$currentNode4.value,
                type = _context$currentNode4.type,
                nodeId = _context$currentNode4.nodeId,
                operator = _context$currentNode4.operator;

            var dataType = context.currentNode.getDataType();
            this.hasValidOperator(operator, value, dataType, type, nodeId);
        }
    }, {
        key: 'visitDocumentTypePredicate',
        value: function visitDocumentTypePredicate(context) {
            var _context$currentNode5 = context.currentNode,
                type = _context$currentNode5.type,
                documentType = _context$currentNode5.documentType,
                nodeId = _context$currentNode5.nodeId;

            if (!documentType) {
                this.errors.add(type, nodeId, DocumentTypeIsMissing);
            }
        }
    }, {
        key: 'visitUploadDatePredicate',
        value: function visitUploadDatePredicate(context) {
            var _context$currentNode6 = context.currentNode,
                value = _context$currentNode6.value,
                type = _context$currentNode6.type,
                nodeId = _context$currentNode6.nodeId,
                operator = _context$currentNode6.operator;

            var dataType = context.currentNode.getDataType();
            this.hasValidOperator(operator, value, dataType, type, nodeId);
        }
    }, {
        key: 'visitUploadUserPredicate',
        value: function visitUploadUserPredicate(context) {
            var _context$currentNode7 = context.currentNode,
                value = _context$currentNode7.value,
                type = _context$currentNode7.type,
                nodeId = _context$currentNode7.nodeId,
                operator = _context$currentNode7.operator;

            var dataType = context.currentNode.getDataType();
            this.hasValidOperator(operator, value, dataType, type, nodeId);
        }

        // valuesets

    }, {
        key: 'visitDatasetFixedValue',
        value: function visitDatasetFixedValue(context) {
            var _context$currentValue = context.currentValueSet,
                value = _context$currentValue.value,
                type = _context$currentValue.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.valueMustBeNonEmpty(value, type, nodeId, property);
        }
    }, {
        key: 'visitDatasetMultiselectList',
        value: function visitDatasetMultiselectList(context) {
            var _context$currentValue2 = context.currentValueSet,
                values = _context$currentValue2.values,
                type = _context$currentValue2.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(values, type, nodeId, property);
            this.eachValueMustBeNonEmpty(values, type, nodeId, property);
        }
    }, {
        key: 'visitDatasetSingleValue',
        value: function visitDatasetSingleValue(context) {
            var _context$currentValue3 = context.currentValueSet,
                values = _context$currentValue3.values,
                type = _context$currentValue3.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(values, type, nodeId, property);
            this.eachValueMustBeNonEmpty(values, type, nodeId, property);
        }
    }, {
        key: 'visitDatasetValueList',
        value: function visitDatasetValueList(context) {
            var _context$currentValue4 = context.currentValueSet,
                values = _context$currentValue4.values,
                type = _context$currentValue4.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(values, type, nodeId, property);
            this.eachValueMustBeNonEmpty(values, type, nodeId, property);
        }
    }, {
        key: 'visitDataSourceSingleValue',
        value: function visitDataSourceSingleValue(context) {
            var _context$currentValue5 = context.currentValueSet,
                dataSourceId = _context$currentValue5.dataSourceId,
                type = _context$currentValue5.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            if (!dataSourceId) {
                this.errors(type, nodeId, DataSourceIdIsMissing, property);
            }
        }
    }, {
        key: 'visitDataSourceMultipleValue',
        value: function visitDataSourceMultipleValue(context) {
            var _context$currentValue6 = context.currentValueSet,
                dataSourceId = _context$currentValue6.dataSourceId,
                type = _context$currentValue6.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            if (!dataSourceId) {
                this.errors(type, nodeId, DataSourceIdIsMissing, property);
            }
        }
    }, {
        key: 'visitDataSourceValueList',
        value: function visitDataSourceValueList(context) {
            var _context$currentValue7 = context.currentValueSet,
                dataSourceId = _context$currentValue7.dataSourceId,
                type = _context$currentValue7.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            if (!dataSourceId) {
                this.errors(type, nodeId, DataSourceIdIsMissing, property);
            }
        }
    }, {
        key: 'visitFixedValue',
        value: function visitFixedValue(context) {
            var _context$currentValue8 = context.currentValueSet,
                value = _context$currentValue8.value,
                type = _context$currentValue8.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.valueMustBeNonEmpty(value, type, nodeId, property);
        }
    }, {
        key: 'visitMultiselectList',
        value: function visitMultiselectList(context) {
            var _context$currentValue9 = context.currentValueSet,
                values = _context$currentValue9.values,
                type = _context$currentValue9.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(values, type, nodeId, property);
            this.eachValueMustBeNonEmpty(values, type, nodeId, property);
        }
    }, {
        key: 'visitScalarValue',
        value: function visitScalarValue(context) {
            // Scalar values are no longer required to have a value filled in at configuration time.
        }
    }, {
        key: 'visitSelectList',
        value: function visitSelectList(context) {
            var _context$currentValue10 = context.currentValueSet,
                values = _context$currentValue10.values,
                type = _context$currentValue10.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(values, type, nodeId, property);
            this.eachValueMustBeNonEmpty(values, type, nodeId, property);
        }
    }, {
        key: 'visitValueList',
        value: function visitValueList(context) {
            var _context$currentValue11 = context.currentValueSet,
                values = _context$currentValue11.values,
                type = _context$currentValue11.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(values, type, nodeId, property);
            this.eachValueMustBeNonEmpty(values, type, nodeId, property);
        }

        // engine

    }, {
        key: 'visitAllFilesQuery',
        value: function visitAllFilesQuery(context) {
            // not implemented. perhaps should remove
        }
    }, {
        key: 'visitBinderIdPredicate',
        value: function visitBinderIdPredicate(context) {
            // not implemented. perhaps should remove
        }
    }, {
        key: 'visitBinderQuery',
        value: function visitBinderQuery(context) {
            // is not really being used currently. perhaps should remove or add query-time validation
            this.mustHaveAtLeastOneChild(context.currentNode);
        }

        // security

    }, {
        key: 'visitDapsSecurityClause',
        value: function visitDapsSecurityClause(context) {
            // is not really being used currently. perhaps should remove or add query-time validation
            this.mustHaveAtLeastOneChild(context.currentNode);
        }
    }, {
        key: 'visitDocumentTypeSecurityClause',
        value: function visitDocumentTypeSecurityClause(context) {
            // not implemented. perhaps should remove
        }
    }, {
        key: 'visitInstitutionSecurityClause',
        value: function visitInstitutionSecurityClause(context) {
            // not implemented. perhaps should remove
        }
    }, {
        key: 'visitSecurityClause',
        value: function visitSecurityClause(context) {
            // is not really being used currently. perhaps should remove or add query-time validation
            this.mustHaveAtLeastOneChild(context.currentNode);
        }
    }]);
    return ValidationVisitor;
}(_QueryNodeVisitor3.default);

var ConfigurationValidationVisitor = function (_ValidationVisitor) {
    (0, _inherits3.default)(ConfigurationValidationVisitor, _ValidationVisitor);

    function ConfigurationValidationVisitor() {
        (0, _classCallCheck3.default)(this, ConfigurationValidationVisitor);
        return (0, _possibleConstructorReturn3.default)(this, (ConfigurationValidationVisitor.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationValidationVisitor)).apply(this, arguments));
    }

    (0, _createClass3.default)(ConfigurationValidationVisitor, [{
        key: 'visitDatasetSingleValue',
        value: function visitDatasetSingleValue(context) {
            (0, _get3.default)(ConfigurationValidationVisitor.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationValidationVisitor.prototype), 'visitDatasetSingleValue', this).call(this, context);
            var _context$currentValue12 = context.currentValueSet,
                selected = _context$currentValue12.selected,
                type = _context$currentValue12.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.valueMustBeNonEmpty(selected, type, nodeId, property);
        }
    }, {
        key: 'visitDatasetMultiselectList',
        value: function visitDatasetMultiselectList(context) {
            (0, _get3.default)(ConfigurationValidationVisitor.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationValidationVisitor.prototype), 'visitDatasetMultiselectList', this).call(this, context);
            var _context$currentValue13 = context.currentValueSet,
                selectedValues = _context$currentValue13.selectedValues,
                type = _context$currentValue13.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(selectedValues, type, nodeId, property);
            this.eachValueMustBeNonEmpty(selectedValues, type, nodeId, property);
        }
    }, {
        key: 'visitDataSourceMultipleValue',
        value: function visitDataSourceMultipleValue(context) {
            (0, _get3.default)(ConfigurationValidationVisitor.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationValidationVisitor.prototype), 'visitDataSourceMultipleValue', this).call(this, context);
            var _context$currentValue14 = context.currentValueSet,
                selectedValues = _context$currentValue14.selectedValues,
                type = _context$currentValue14.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(selectedValues, type, nodeId, property);
            this.eachValueMustBeNonEmpty(selectedValues, type, nodeId, property);
        }
    }, {
        key: 'visitDataSourceSingleValue',
        value: function visitDataSourceSingleValue(context) {
            (0, _get3.default)(ConfigurationValidationVisitor.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationValidationVisitor.prototype), 'visitDataSourceSingleValue', this).call(this, context);
            var _context$currentValue15 = context.currentValueSet,
                value = _context$currentValue15.value,
                type = _context$currentValue15.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.valueMustBeNonEmpty(value, type, nodeId, property);
        }
    }, {
        key: 'visitScalarValue',
        value: function visitScalarValue(context) {
            var _context$currentValue16 = context.currentValueSet,
                value = _context$currentValue16.value,
                type = _context$currentValue16.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.valueMustBeNonEmpty(value, type, nodeId, property);
        }
    }, {
        key: 'visitSelectList',
        value: function visitSelectList(context) {
            (0, _get3.default)(ConfigurationValidationVisitor.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationValidationVisitor.prototype), 'visitSelectList', this).call(this, context);
            var _context$currentValue17 = context.currentValueSet,
                selected = _context$currentValue17.selected,
                type = _context$currentValue17.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.valueMustBeNonEmpty(selected, type, nodeId, property);
        }
    }, {
        key: 'visitMultiselectList',
        value: function visitMultiselectList(context) {
            (0, _get3.default)(ConfigurationValidationVisitor.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationValidationVisitor.prototype), 'visitMultiselectList', this).call(this, context);
            var _context$currentValue18 = context.currentValueSet,
                selectedValues = _context$currentValue18.selectedValues,
                type = _context$currentValue18.type;
            var nodeId = context.currentNode.nodeId;

            var property = context.currentDataKey;
            this.mustHaveAtLeastOneValue(selectedValues, type, nodeId, property);
            this.eachValueMustBeNonEmpty(selectedValues, type, nodeId, property);
        }
    }]);
    return ConfigurationValidationVisitor;
}(ValidationVisitor);